import animation from "./animation.js";
import audio from "./audio.js";
import elevation from "./elevation.js";
import files from "./files.js";
import levels from "./levels.js";
import moves from "./moves.js";
import opacity from "./opacity.js";
import rotation from "./rotation.js";
import scale from "./scale.js";
import time from "./time.js";
import users from "./users.js";
import filter from "./filter.js";
import tint from "./tint.js";
import blendMode from "./blendMode.js";
import location from "./location.js";
import offset from "./offset.js";
import text from "./text.js";
import name from "./name.js";

export default {
  animation,
  audio,
  elevation,
  files,
  levels,
  moves,
  opacity,
  rotation,
  scale,
  time,
  users,
  filter,
  tint,
  blendMode,
  location,
  offset,
  text,
  name
};
